/**
 * Yetki matrisi istemci tarafı — 25.08 md, madde 6.
 *
 * App.js'teki 55 korumalı rotanın 52'si `PermissionBasedRoute`'a tip/anahtar
 * GEÇİRMİYORDU; bileşen prop yoksa bilinçli olarak salt oturum kapısına
 * dönüşüyordu. 52 rotayı tek tek düzenlemek yerine matris backend'de tek yerde
 * (`services/yetki_matris.py`) durur, buradan bir kez çekilir ve geçerli
 * pathname'e göre uygulanır. Menü süzmesi ve API middleware'i AYNI tabloyu
 * kullanır, böylece üç halka birbirinden ayrışamaz.
 *
 * Matris oturum başına bir kez çekilir (söz önbelleklenir).
 */
import axios from 'axios';
import { API_BASE_URL } from './config';

let _sozu = null;

/** Matrisi (ve kullanıcının hesaplanmış izinlerini) getirir; bir kez çeker. */
export const matrisiGetir = () => {
  if (_sozu) return _sozu;
  _sozu = axios
    .get(`${API_BASE_URL}/yetki/matris`)
    .then((r) => r.data)
    .catch((e) => {
      // Matris alınamazsa kapıyı KAPATMIYORUZ: aksi halde geçici bir ağ
      // hatası tüm uygulamayı erişilemez yapardı. Backend middleware'i
      // zaten son sözü söylüyor.
      console.warn('[yetki-matris] alınamadı, ekran kapıları atlanıyor:', e?.message);
      return null;
    });
  return _sozu;
};

/** Oturum kapanınca önbelleği temizle (yeni kullanıcı farklı izinlere sahip). */
export const matrisiUnut = () => {
  _sozu = null;
};

/** `/ik/personel/:kullaniciNo` gibi desenleri gerçek yola karşılar. */
const desenUyuyor = (desen, yol) => {
  const re = new RegExp('^' + desen.replace(/:[^/]+/g, '[^/]+') + '/?$');
  return re.test(yol || '');
};

/**
 * Geçerli yol için gereken yetki.
 * @returns {{tip: string, anahtar: string, tur: string}|null}
 */
export const yolYetkisi = (matris, yol) => {
  if (!matris?.rotalar) return null;
  return matris.rotalar.find((r) => desenUyuyor(r.desen, yol)) || null;
};

/**
 * Kullanıcı bu yola girebilir mi?
 *
 * Rapor modunda (backend `zorlama_acik=false`) yalnızca `zorla_kapali`
 * listesindeki yetkiler gerçekten engeller — geri kalanı geçer. Sebep:
 * canlıda aktif kullanıcıların yarısına yakınının `pozisyon` alanı boş ve
 * pozisyonsuz kullanıcı hiçbir yetkiyi geçemiyor; doğrudan zorlama onları
 * anında dışlardı.
 */
export const yolaGirebilir = (matris, yol) => {
  if (!matris) return true;
  const gereken = yolYetkisi(matris, yol);
  if (!gereken) return true;

  const izin = matris.izinler?.[`${gereken.tip}|${gereken.anahtar}`];
  if (izin?.[gereken.tur]) return true;

  const zorlanir =
    matris.zorlama_acik ||
    (matris.zorla_kapali || []).some(
      (z) => z.tip === gereken.tip && z.anahtar === gereken.anahtar
    );
  return !zorlanir;
};

export default { matrisiGetir, matrisiUnut, yolYetkisi, yolaGirebilir };
